import { Box, Stack, TextField, Typography } from "@mui/material";
import { LegacyRef, useCallback } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useQrScanner from "hooks/useQrScanner";
import { useZxing } from "react-zxing";

export default function ScanStep() {
  const navigate = useNavigate();
  const { activeDeviceId } = useOutletContext() as { activeDeviceId: string };
  const { ref } = useZxing({
    deviceId: activeDeviceId,
    onDecodeResult(result) {
      handleSubmitInventoryId({ inventoryId: result.getText() });
    },
  });
  const handleSubmitInventoryId = useCallback(
    async (values: { inventoryId: string }) => {
      navigate(`../${values.inventoryId}/capture`);
    },
    [navigate],
  );

  const readCompleted = useCallback(
    (scannedValue: string | null | undefined) => {
      if (!scannedValue) return;
      const isInventoryId = (value: string): boolean => !isNaN(Number(value));
      if (isInventoryId(scannedValue)) {
        handleSubmitInventoryId({ inventoryId: scannedValue });
      }
    },
    [handleSubmitInventoryId],
  );

  const { readerProps } = useQrScanner({ readCompleted });

  return (
    <Box component={Stack} spacing={2}>
      <Typography>Scan an inventory using the QR code on the label.</Typography>
      <Box>
        {activeDeviceId && (
          <video ref={ref as LegacyRef<HTMLVideoElement>} style={{ width: 480, aspectRatio: "1/1" }} />
        )}
      </Box>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.currentTarget);
          handleSubmitInventoryId({ inventoryId: formData.get("inventoryId") as string });
        }}
      >
        <TextField name="inventoryId" label="Inventory ID" size="small" />
      </form>
    </Box>
  );
}
